export default {
  prod: "production",
  stage: "staging",
  devServer: "devserver",
  devOld: "dev-old",
  get envProd() {
    return process.env.REACT_APP_ENV === this.prod;
  },
  get envStage() {
    return process.env.REACT_APP_ENV === this.stage;
  },
  get envDevServer() {
    return process.env.REACT_APP_ENV === this.devServer;
  },
  get envDevOld() {
    return process.env.REACT_APP_ENV === this.devOld;
  },
  get prodUrl() {
    if (typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.indexOf("fullertonhealth.co.id") !== -1) {
      return "https://rest-api.fullertonhealth.co.id";
    }
    return "https://rest-api.fhnid.com";
  },
  get devServerUrl() {
    if (typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.indexOf("fullertonhealth.co.id") !== -1) {
      return "https://dev-api-hdc.fullertonhealth.co.id";
    }
    return "https://dev-api-hdc.fhnid.com";
  },
  stgUrl: "https://stg-api-hdc.fhnid.com",
  devUrl: "http://localhost:3003",
  get devOldUrl() {
    if (typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.indexOf("fullertonhealth.co.id") !== -1) {
      return "https://dev-api-hdc.fullertonhealth.co.id";
    }
    return "https://dev-api-hdc.fhnid.com";
  },
  ssoDevUrl: "https://uat-erp.fhnid.com",
  ssoUATUrl: "https://uat-erp.fhnid.com",
  ssoProdUrl: "https://erp.fhnid.com",

  get bannerBgF1() {
    return process.env.REACT_APP_ENV === this.prod
      ? "https://apiv2.fhnid.com/uploads/hdc/banner-f1.png"
      : "https://dev-apiv2.fhnid.com/uploads/hdc/banner-f1.png";
  },
  get imgModalF1() {
    return process.env.REACT_APP_ENV === this.prod
      ? "https://apiv2.fhnid.com/uploads/hdc/modal-f1-banner.png"
      : "https://dev-apiv2.fhnid.com/uploads/hdc/modal-f1-banner.png";
  },
};
